export function getToneStyles(tone: "critical" | "neutral" | "positive") {
    if (tone === "critical") {
        return {
            backgroundColor: "rgba(220, 38, 38, 0.045)",
            border: "1px solid rgba(220, 38, 38, 0.12)",
            color: "#9f1239",
        };
    }

    if (tone === "positive") {
        return {
            backgroundColor: "rgba(15, 118, 110, 0.05)",
            border: "1px solid rgba(15, 118, 110, 0.12)",
            color: "#0f766e",
        };
    }

    return {
        backgroundColor: "rgba(15, 23, 42, 0.025)",
        border: "1px solid rgba(148, 163, 184, 0.16)",
        color: "#475569",
    };
}
